"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["to", "children", "disabled", "className", "theme", "testId", "target"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  disabled: false,
  target: '_self',
  onClick: function onClick() {},
  theme: {}
};

/**
 * Display a link element containing plain text or any children.
 */
var Link = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Link, _React$Component);
  function Link(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Link);
    _this = _callSuper(this, Link, [props]);
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Link, [{
    key: "onClick",
    value: function onClick(e) {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick;
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      onClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        to = _this$props2.to,
        children = _this$props2.children,
        disabled = _this$props2.disabled,
        className = _this$props2.className,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        target = _this$props2.target,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      delete props.onClick;
      var resultClassName = (0, _classnames["default"])(className, theme.link, (0, _defineProperty2["default"])({}, theme.disabled, disabled));
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: resultClassName,
        "data-test-id": testId,
        "data-anypoint-component": Link.displayName
      }, /*#__PURE__*/_react["default"].createElement("a", {
        "aria-disabled": disabled,
        target: target,
        href: to,
        onClick: this.onClick
      }, children));
    }
  }]);
  return Link;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Link, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Link, "displayName", 'Link');
//# sourceMappingURL=Link.js.map